// Model for fetching IMS (MyCase automation) data by email_id

const IMS_BACKEND_BASE = process.env.REACT_APP_IMS_BACKEND_BASE || 'https://imsbackend.techvelocity.ai';

// Fetch mapping record(s) for a given email_id
export async function getIMSMappingByEmail(emailId) {
  if (!emailId) return null;
  try {
    // Query tasks endpoint with email_id as parameter
    const tasksUrl = `${IMS_BACKEND_BASE}/tasks?email_id=${encodeURIComponent(emailId)}`;
    const eventsUrl = `${IMS_BACKEND_BASE}/events?email_id=${encodeURIComponent(emailId)}`;

    const [tasksResp, eventsResp] = await Promise.all([
      fetch(tasksUrl, { headers: { Accept: 'application/json' }, cache: 'no-cache' }),
      fetch(eventsUrl, { headers: { Accept: 'application/json' }, cache: 'no-cache' }).catch(() => null)
    ]);

    let tasks = [];
    if (tasksResp && tasksResp.ok) {
      const tasksJson = await tasksResp.json();
      if (Array.isArray(tasksJson)) {
        tasks = tasksJson.map(t => {
          if (!t) return null;
          const id = t.id || t.task_id || t.taskId || null;
          const name = t.task_name || t.name || t.title || '';
          const description = t.description || t.body || '';
          const due_date = t.due_date || t.dueDate || null;
          const priority = t.priority || t.priority_level || t.priorityLevel || '';
          return id ? { id: Number(id), task_name: name, description, due_date, priority } : null;
        }).filter(Boolean);
      }
    }

    let events = [];
    if (eventsResp && eventsResp.ok) {
      try {
        const eventsJson = await eventsResp.json();
        if (Array.isArray(eventsJson)) {
          events = eventsJson.map(e => {
            if (!e) return null;
            const id = e.id || e.event_id || e.eventId || null;
            const title = e.title || e.name || '';
            const description = e.description || e.body || '';
            // start datetime may be in ISO format; normalize to date-only (YYYY-MM-DD)
            const rawStart = e.start_datetime || e.startDate || e.start || e.datetime || null;
            let start_date = null;
            if (rawStart) {
              try {
                if (typeof rawStart === 'string' && rawStart.includes('T')) {
                  start_date = rawStart.split('T')[0];
                } else {
                  const d = new Date(rawStart);
                  if (!isNaN(d.getTime())) start_date = d.toISOString().split('T')[0];
                }
              } catch (_err) {
                start_date = null;
              }
            }
            return id ? { id: Number(id), title, description, start_date } : null;
          }).filter(Boolean);
        }
      } catch (e) {
        // ignore parse errors
      }
    }

    return {
      record: null,
      tasks,
      events,
    };
  } catch (err) {
    console.error('IMS fetch error:', err);
    throw err;
  }
}
